package com.essntl.features.crm.ui.components

import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.withStyle
import kotlinx.coroutines.delay

@Composable
fun SearchHighlightedText(
    text: String,
    query: String,
    textStyle: TextStyle = LocalTextStyle.current,
    textColor: Color = Color.Unspecified,
) {
    var delayedQuery by remember { mutableStateOf(query) }

    // Delay the highlighting by 500ms (this simulates the delay you're looking for)
    LaunchedEffect(query) {
        if (query.isNotEmpty()) {
            delay(500) // Add the delay before starting highlighting
            delayedQuery = query // Update the query to trigger the highlighting
        }
    }

    val annotatedString = buildAnnotatedString {
        var startIndex = 0
        var endIndex: Int

        if (delayedQuery.isNotEmpty()) {
            while (startIndex < text.length) {
                endIndex = text.indexOf(delayedQuery, startIndex, ignoreCase = true)
                if (endIndex == -1) break

                // Add text before the match without styling
                append(text.substring(startIndex, endIndex))

                // Highlight the match
                withStyle(style = SpanStyle(background = Color.Yellow)) {
                    append(text.substring(endIndex, endIndex + delayedQuery.length))
                }

                // Update the start index for next match search
                startIndex = endIndex + delayedQuery.length
            }

            // Append the remaining part of the text after the last match
            append(text.substring(startIndex))
        } else {
            // If query is empty, just show normal text
            append(text)
        }
    }

    Text(
        text = annotatedString,
        color = textColor,
        style = textStyle,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
    )
}
